<template>
  <div>
    <div class="pay-image-header">
      <img src="../assets/china-bank.png" alt='loading'></img>
    </div>
    <div class="payment">
      <div class="pay-header-error">
        <span class="title-new">Bank of China</span>
      </div>
      <div class="pay-middle">
        <div class="status-info">
          Status:
          <a href="#" style="color:red">{{paymentModel.status}}</a>
          </br>
          Reference number:{{paymentModel.debitAuthNo}}
          </br>
          Transaction date:{{paymentModel.tranDate}}
          </br>
          Transaction time:{{paymentModel.tranTime.replace("-",":").replace("-",":")}}
        </div>

        <div class="pay-row-success row-status1">
          <span class="row-status-name1">Amount:</span>
          <span>{{paymentModel.accountCurrency}}&nbsp;{{paymentModel.tranAmount}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name2">Fee Amount:</span>
          <span>{{paymentModel.accountCurrency}}&nbsp;{{paymentModel.feeAmount}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name3">From Account:</span>
          <span>{{paymentModel.accounNo}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name4">Buyer Name:</span>
          <span>{{paymentModel.buyerName}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name5">Merchant Name:</span>
          <span>{{paymentModel.sellerDesc}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name6">Payment Reference:</span>
          <span>{{paymentModel.sellerOrderNo}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name7">FPX Transaction ID:</span>
          <span>{{paymentModel.fpxTranId}}</span>
        </div>
        <div class="pay-button">
          <el-button @click="next()" type="danger">Continue with Transaction ({{toTime}}s)</el-button>
        </div>
      </div>
      <div class="payfoot"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PaymentError",
    data() {
      return {
        toTime: 10,
        active: 3,
        paymentModel: {
          status: 'Unsuccessful',
          makerName: '',
          sellerOrderNo: '',
          fpxTranId: '',
          tranAmount: '',
          feeAmount: '',
          accounNo: '',
          buyerName: '',
          accountCurrency: '',
          opxpPaymentNo: '',
          tranDate: '',
          tranTime: '',
        },
      };
    },

    created() {
      this.getUnsuccessfulResult();
      let taskid = setInterval(() => {
        if (this.toTime > 1) {
          this.toTime--;
        } else {
          clearInterval(taskid);
          this.next();
        }
      }, 1000);
    },

    methods: {
      next() {
        window.sessionStorage.setItem('message', "Payment unsuccessful and you have log out.")
        this.$router.replace({ name: 'ReturnToFpx' })
      },

      /**
       * 获取支付结果
       **/
      getUnsuccessfulResult() {
        let unsuccessfulResult = JSON.parse(window.sessionStorage.getItem('Unsuccessful'));
        window.sessionStorage.setItem('indirectURL', unsuccessfulResult.respUrl);
        for (let key in unsuccessfulResult) {
          this.paymentModel[key] = unsuccessfulResult[key]
        }
      },
    },
  }
</script>

<style lang='less' scoped>
  @media screen and (max-width: 640px) {
    @import "../styles/mobile/m_payment.less";
  }

  @media screen and (min-width: 641px) {
    @import "../styles/pc/payment.less";
  }
</style>


// WEBPACK FOOTER //
// src/views/PayErrorPage.vue